// All Projects paint inspections: last N days across jobs. Loaded only when this tab is selected.
import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";

import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";
import DaysSelector from "modules/5_view_helpers/web/DaysSelector";
import TableTorch from "modules/5_view_helpers/web/TableTorch";

import { getAllProjectQaPaintInspections } from "../actions";
import paintInspectionColumns, { sectionReadingsChild } from "./columns";

const AllProjectsPaintInspections = ({ days, onDaysChange }) => {
  const [inspections, setInspections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getAllProjectQaPaintInspections(days)
      .then((res) => {
        if (!cancelled) setInspections(res.data || []);
      })
      .catch(() => {
        if (!cancelled) setInspections([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [days]);

  const readRole = HasRole({ resource_type: "Project::Qa::PaintInspection", name: ["read", "moderator"] });
  const updateRole = HasRole({ resource_type: "Project::Qa::PaintInspection", name: ["update", "moderator"] });

  if (!readRole) return <NotAuthorized />;

  return (
    <Card>
      <CardHeader>
        <Row className="align-items-center">
          <Col>
            <h3>All Projects Paint inspections</h3>
          </Col>
          <Col xs="auto">
            <DaysSelector value={days} onChange={onDaysChange} />
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        {loading && <div className="text-muted">Loading paint inspections…</div>}
        {!loading && _.isEmpty(inspections) && (
          <div className="text-muted">
            No paint inspections in the last {days} day{days == 1 ? "" : "s"}.
          </div>
        )}
        {!loading && _.isNotEmpty(inspections) && (
          <TableTorch
            columns={paintInspectionColumns({ updateRole, allProjects: true })}
            data={inspections}
            selectable
            initialGroupBy={[{ label: "Project", value: "project_display_name" }]}
            childComponent={sectionReadingsChild}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default AllProjectsPaintInspections;
